
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoratnagiriinnovacrystacar() {



    const cardData =
    {
        keyword: 'Pune to Ratnagiri Innova Crysta Car Rental',
        heading: 'Meghana Cab : Pune to Ratnagiri Innova Crysta Car Rental',
        headingDescription: 'Meghana Cab offers Pune to Ratnagiri Innova Crysta Car Rental, ensuring a comfortable, spacious, and stress-free journey of approximately 290–300 km along the scenic Konkan route through Satara, Kolhapur, and NH 66 (about 6–7 hours). Ideal for family outings, corporate trips, or leisurely vacations, our leather‑interior Innova Crysta vehicles offer ample legroom, generous luggage space, and air‑conditioning to enhance your travel comfort. With experienced chauffeurs, door‑to‑door pickup from anywhere in Pune, GPS‑enabled vehicles, and 24/7 customer support, Meghana Cab ensures your Pune to Ratnagiri Innova Crysta journey is smooth, safe, and truly enjoyable—letting you sit back, relax, and savor every mile.',


        top: 'Top Places to Visit in Ratnagiri with Meghana Cab',

"topPlaces": [
  {
    "title": "Ratnadurg Fort",
    "description": "Also known as Bhagawati Fort, this 16th-century sea fort perches atop a rocky promontory just 2 km from Ratnagiri town. The fort’s sturdy bastions, an inside Bhagawati temple, lighthouse, well, and cave offer a scenic walk with sweeping Arabian Sea views—ideal for history buffs and photographers alike."
  },
  {
    "title": "Jaigad Fort & Lighthouse",
    "description": "Set on a cliff at the mouth of the Shastri River, Jaigad Fort is a dramatic coastal citadel dating to Bijapur Sultanate and later fortified under Maratha admiral Kanhoji Angre. Its ramparts, lighthouse, and jetty reveal panoramic views of the sea and local fishing life. The ruins and vantage points make it a Konkan must-visit."
  },
  {
    "title": "Swayambhu Ganapati Temple & Ganpatipule Beach",
    "description": "About 35 km from Ratnagiri, Ganpatipule is famed for its pristine silver sands and the 400‑year‑old self‑manifested Ganapati idol embedded in white sand. The temple and beach combo make it a leading spiritual and seaside escape—cool sea breeze, coastal devotion, and stunning sunsets."
  },
  {
    "title": "Purnagad Fort",
    "description": "Perched at the confluence of Muchkundi creek and the Arabian Sea, this lesser-known Maratha-era fort offers rugged coastal vistas, a Hanuman shrine, and a historic well. With fewer tourists, Purnagad is perfect for quiet exploration and dramatic sea views."
  },
  {
    "title": "Tilak Ali Museum",
    "description": "The ancestral home of Lokmanya Bal Gangadhar Tilak, this museum showcases originals—photographs, letters, relics—and reflects Konkan-style architecture. A meaningful stop for history enthusiasts tracing India’s independence journey."
  },
  {
    "title": "Patit Pavan Mandir",
    "description": "Built in 1931 by freedom fighter Veer Savarkar, this temple broke caste barriers by allowing entry to all communities. It’s a historic beacon of social reform and spiritual aspiration, hosting open prayers and annual Ganesh festivals."
  },
  {
    "title": "Bhatye & Mandvi Beaches",
    "description": "Close to the city, Mandvi and adjacent Bhatye Beach offer long, serene stretches of golden sand backed by Sahyadri foothills. These family-friendly beaches are ideal for sunsets, casual strolls, and local snacks without the crowds."
  },
  {
    "title": "Pawas & Thibaw Palace",
    "description": "Pawas is a serene temple town associated with saint Swami Swaroopanand, while nearby Thibaw Palace was once the exile residence of Burma’s last king. Both sites blend spiritual calm and colonial-era intrigue."
  },
  {
    "title": "Panhalakaji Caves",
    "description": "About 20 km inland, Panhalakaji houses 29 rock-cut caves—Buddhist and later Hindu—dating from the 3rd to 11th centuries. The complex includes stupas, Brahmi inscriptions, and sculptural reliefs, linked by forest trails beside the Kotjai stream."
  },
  {
    "title": "Gopalgad (Anjanvel) & Mandangad Forts",
    "description": "Sea forts like Gopalgad (Anjanvel) and hill forts like Mandangad offer rugged trekking, Maratha-era cannons, forest views, and religious sites like Ganpati shrines—ideal for adventurous history seekers."
  }
],

        "services": [
    {
      "name": "Pune to Ratnagiri Innova Crysta Cab Booking",
      "description": "Book a premium Innova Crysta cab from Pune to Ratnagiri for a comfortable and scenic journey along the Konkan route. Enjoy spacious seating, smooth suspension, and professional chauffeur service as you travel through the lush Western Ghats to the coastal city of Ratnagiri."
    },
    {
      "name": "One Way Innova Crysta Pune Ratnagiri",
      "description": "Choose our affordable one-way Innova Crysta cab for your journey from Pune to Ratnagiri. Ideal for solo travelers or families relocating or vacationing, this service offers convenience without the burden of return charges."
    },
    {
      "name": "Round Trip Innova Crysta Pune Ratnagiri",
      "description": "Planning a return journey? Opt for our round trip Innova Crysta cab service from Pune to Ratnagiri. You’ll benefit from flexible return schedules, a single cab for both journeys, and a stress-free travel experience."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Ratnagiri",
      "description": "Beat the coastal heat with our fully air-conditioned Innova Crysta taxis. Travel from Pune to Ratnagiri in a climate-controlled cabin that ensures maximum comfort over long distances."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Ratnagiri",
      "description": "Our well-trained, courteous chauffeurs will take you safely from Pune to Ratnagiri. Enjoy peace of mind with reliable driving, local route knowledge, and personalized assistance throughout your trip."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Ratnagiri",
      "description": "Book a private Innova Crysta taxi exclusively for your group. Enjoy complete privacy, flexibility in travel times, and a quiet, spacious cabin for family or corporate trips to Ratnagiri."
    },
    {
      "name": "Online Booking Innova Crysta Pune Ratnagiri",
      "description": "Secure your Pune to Ratnagiri cab in just a few clicks with our online booking system. Benefit from real-time availability, upfront pricing, instant confirmations, and flexible pickup options."
    },
    {
      "name": "Ratnagiri Tour Innova Crysta",
      "description": "Extend your trip with a Ratnagiri tour in our Innova Crysta. Visit local beaches, forts, mango farms, and more with a comfortable and reliable cab waiting at your convenience."
    },
    {
      "name": "Ratnagiri Airport Transfer Innova Crysta",
      "description": "We offer timely airport transfers to and from Ratnagiri Airport in our Innova Crysta cabs. Ideal for travelers catching flights or arriving in Ratnagiri, our service guarantees punctuality and comfort."
    },
    {
      "name": "Family Travel Innova Crysta Ratnagiri",
      "description": "Traveling with family? Our Innova Crysta cabs offer 6-7 seater comfort with ample luggage space, AC, and reclining seats—perfect for a smooth, enjoyable ride to Ratnagiri for your loved ones."
    },
    {
      "name": "Budget Innova Crysta Taxi Pune Ratnagiri",
      "description": "Our budget-friendly Innova Crysta cabs offer luxury at an affordable price. Get competitive rates without compromising on comfort or vehicle quality for your Pune to Ratnagiri journey."
    },
    {
      "name": "Comfortable Innova Crysta Cab Pune Ratnagiri",
      "description": "Experience unmatched comfort in our Innova Crysta cabs, ideal for long-distance trips like Pune to Ratnagiri. Enjoy soft seats, smooth rides, and noise-insulated cabins on the scenic drive."
    },
    {
      "name": "Reliable Pune Ratnagiri Innova Crysta",
      "description": "We take pride in our dependable service. From on-time pickups to courteous drivers and well-maintained vehicles, our Pune to Ratnagiri Innova Crysta cabs ensure a worry-free experience."
    },
    {
      "name": "Long Distance Innova Crysta Taxi",
      "description": "Our Innova Crysta taxis are designed for long-distance travel with robust performance, plush interiors, and experienced drivers. Perfect for extended drives like Pune to Ratnagiri."
    },
    {
      "name": "Premium Cab Hire Pune Ratnagiri",
      "description": "Upgrade your journey with our premium Innova Crysta cab hire. Enjoy captain seats, leather interiors, and VIP-level service—perfect for executives, NRIs, or anyone seeking top-tier travel comfort."
    }
  ],
  "tableData": [
    ["Pune to Ratnagiri Innova Crysta Cab Booking", "One Way Innova Crysta Pune Ratnagiri"],
    ["Round Trip Innova Crysta Pune Ratnagiri", "AC Innova Crysta Taxi Pune Ratnagiri"],
    ["Chauffeur Driven Innova Crysta Pune Ratnagiri", "Private Innova Crysta Taxi Pune Ratnagiri"],
    ["Online Booking Innova Crysta Pune Ratnagiri", "Ratnagiri Tour Innova Crysta"],
    ["Ratnagiri Airport Transfer Innova Crysta", "Family Travel Innova Crysta Ratnagiri"],
    ["Budget Innova Crysta Taxi Pune Ratnagiri", "Comfortable Innova Crysta Cab Pune Ratnagiri"],
    ["Reliable Pune Ratnagiri Innova Crysta", "Long Distance Innova Crysta Taxi"],
    ["Premium Cab Hire Pune Ratnagiri", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable Innova Crysta Car Rental from Pune to Ratnagiri",
    "WhyChoosedescription": "Travel in style and comfort from Pune to Ratnagiri with our premium Innova Crysta rental service. Ideal for family vacations, business trips, or coastal getaways, enjoy a smooth ride along the scenic Konkan route."
  },
  {
    "WhyChooseheading": "Spacious Interiors for Long-Distance Travel",
    "WhyChoosedescription": "Our Innova Crysta vehicles accommodate up to 6–7 passengers with ample legroom and luggage space. Dual AC and plush seating make the approximately 340 km journey comfortable for all travelers."
  },
  {
    "WhyChooseheading": "Professional Drivers Experienced with Konkan Routes",
    "WhyChoosedescription": "Our skilled drivers are well-acquainted with the Pune to Ratnagiri highways and local roads. They prioritize safety and comfort, ensuring timely travel with convenient stops and assistance throughout the trip."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
    "WhyChoosedescription": "We maintain high standards of hygiene and regular vehicle maintenance, guaranteeing a safe and pleasant journey. Each Innova Crysta is sanitized before every trip to ensure passenger health and comfort."
  },
  {
    "WhyChooseheading": "Flexible Booking for One-Way or Round Trips",
    "WhyChoosedescription": "Choose from one-way drops, round trips, or multi-day rentals depending on your travel plans. Customize your itinerary to include stops at popular beaches, forts, or local attractions along the way."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing includes fuel, tolls, driver allowances, and taxes, offering complete transparency and great value. Get clear quotes upfront for your Pune to Ratnagiri Innova Crysta rental."
  },
  {
    "WhyChooseheading": "Ideal for Family Outings, Corporate Travel, and Group Trips",
    "WhyChoosedescription": "Whether traveling with family, colleagues, or friends, our Innova Crysta cabs provide the comfort, space, and reliability needed for a memorable journey along the beautiful Konkan coast."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking and Assistance",
    "WhyChoosedescription": "Our customer service team is available around the clock to help with bookings, itinerary adjustments, and travel queries, ensuring a smooth and hassle-free rental experience."
  }
]



















    }

const faqData = [
    {
        question: "How can I rent an Innova Crysta from Pune to Ratnagiri?",
        answer: "You can rent an Innova Crysta by calling Meghana Cab at +91 9075462128 or booking directly through our website."
    },
    {
        question: "What is the distance and travel time from Pune to Ratnagiri?",
        answer: "The distance is around 310 km and the journey takes approximately 6 to 7 hours depending on the route and traffic."
    },
    {
        question: "Is Innova Crysta comfortable for a trip to Ratnagiri?",
        answer: "Yes, the Innova Crysta offers premium comfort, ample space, and smooth performance — ideal for long trips like Pune to Ratnagiri."
    },
    {
        question: "Can I choose a one-way or round-trip rental to Ratnagiri?",
        answer: "Yes, we offer both one-way and round-trip car rental services between Pune and Ratnagiri."
    },
    {
        question: "How many people can travel in the Innova Crysta?",
        answer: "The Innova Crysta can accommodate 6 to 7 passengers comfortably, along with luggage."
    },
    {
        question: "What’s included in the Pune to Ratnagiri car rental fare?",
        answer: "The fare includes fuel, driver allowance, and toll charges. Parking and extra waiting time may incur additional costs."
    },
    {
        question: "Is the cab sanitized before each journey?",
        answer: "Yes, all our vehicles are thoroughly cleaned and sanitized before every trip."
    },
    {
        question: "Can I schedule stops during the journey to Ratnagiri?",
        answer: "Yes, we can arrange meal breaks or sightseeing stops if requested in advance."
    },
    {
        question: "Are drivers familiar with the Konkan route to Ratnagiri?",
        answer: "Yes, our experienced drivers are well-acquainted with the Konkan region and ensure a safe and pleasant drive."
    },
    {
        question: "What are the payment options available?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Nitin Gawde',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Smooth and scenic ride from Pune to Ratnagiri in a well-maintained Innova Crysta. Highly recommended service!”',
    },
    {
        name: 'Ms. Swati Kamat',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent car rental experience. Our family trip to Ratnagiri was comfortable and timely, thanks to Meghana Cab.”',
    },
];





























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];











const puneRatnagiriInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Ratnagiri Innova Crysta Car Rental",
  "description": "Comfortable and reliable Innova Crysta taxi service from Pune to Ratnagiri for tours, airport transfers, family travel, and long-distance trips. Chauffeur-driven and affordable premium cab hire.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Ratnagiri"
    }
  ],
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-ratnagiri-innova-crysta-car-rental"
  }
};




    return (
        <div>

<Helmet>
  <title>Pune to Ratnagiri Innova Crysta Car Rental | Reliable Taxi Service</title>
  <meta
    name="description"
    content="Book Innova Crysta cabs from Pune to Ratnagiri for tours, airport transfers, family travel, and long-distance trips. Affordable and chauffeur-driven taxi service."
  />
  <meta
    name="keywords"
    content="Pune to Ratnagiri Innova Crysta Cab Booking, One Way Innova Crysta Pune Ratnagiri, Round Trip Innova Crysta Pune Ratnagiri, AC Innova Crysta Taxi Pune Ratnagiri, Chauffeur Driven Innova Crysta Pune Ratnagiri, Private Innova Crysta Taxi Pune Ratnagiri, Online Booking Innova Crysta Pune Ratnagiri, Ratnagiri Tour Innova Crysta, Ratnagiri Airport Transfer Innova Crysta, Family Travel Innova Crysta Ratnagiri, Budget Innova Crysta Taxi Pune Ratnagiri, Comfortable Innova Crysta Cab Pune Ratnagiri, Reliable Pune Ratnagiri Innova Crysta, Long Distance Innova Crysta Taxi, Premium Cab Hire Pune Ratnagiri"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneRatnagiriInnovaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/16.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoratnagiriinnovacrystacar;